import { useEffect } from "react";
import { useOperationStore } from "../stores/operationStore";
import { TOperationData } from "../types/operation";
import { getOperations } from "../services/api-server/operations";

const getOperationIdFromPath = (pathname: string): string | null => {
	const match = pathname.match(/^\/projects\/([^/]+)\/([^/]+)/);
	const operationId = match ? match[2] : null;
	if (
		operationId === null ||
		operationId === "multi-asset" ||
		operationId === "well-examination"
	) {
		return null;
	}
	return operationId;
};

function useInitOperation(currentTenantKey: string | null) {
	const { operation, setOperation } = useOperationStore();
	const operationId = getOperationIdFromPath(location.pathname);

	useEffect(() => {
		if (!currentTenantKey) return;
		if (!operationId) {
			setOperation({} as TOperationData);
			return;
		}
		if (!operation || operation._id !== operationId) {
			getOperations(currentTenantKey, {
				operation_code: operationId,
			}).then((operation: any) => {
				if (operation && operation.length > 0) {
					setOperation(operation[0]);
				}
			});
		}
	}, [operationId, currentTenantKey]);
}

export default useInitOperation;
